import { Marker } from "maplibre-gl";
import { get, writable } from "svelte/store";
import { ProfileRowManager } from "./profiles/ProfileRowManager";
import { ScoreUtis } from "../../../map/controls/layers/trips/dbs/Score";
export class RoutingManager {
    constructor(parent, settings) {
        this.fromStore = writable(undefined);
        this.toStore = writable(undefined);
        this.scoreStore = writable({
            comfort: 0,
            distance: 0,
            safety: 0,
            time: 0
        });
        this.OwnershipKey = "router";
        this.parent = parent;
        this.profiles = settings.profiles;
        this.profileManagers = settings.settings.map(s => {
            return new ProfileRowManager(this, s);
        });
        this.profileManagers.forEach(pm => {
            pm.getRouteStore().subscribe(() => this.updateScore());
            pm.getVisibleStore().subscribe(() => this.updateScore());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    async initialize() {
    }
    async addToMap(map) {
        this.map = map;
        this.profileManagers.forEach(pm => {
            pm.addToMap(this.map);
        });
    }
    getScoreStore() {
        return this.scoreStore;
    }
    getBranchCommitIdStore() {
        return this.parent.getBranchCommitIdStore();
    }
    getFromStore() {
        return this.fromStore;
    }
    getToStore() {
        return this.toStore;
    }
    getProfiles() {
        return this.profiles;
    }
    getProfileManagers() {
        return this.profileManagers;
    }
    reverse() {
        const to = this.from.getLngLat();
        const from = this.to.getLngLat();
        this.from.remove();
        this.to.remove();
        this.createFromMarker(from);
        this.createToMarker(to);
        this.fromStore.set(undefined);
        this.toStore.set(this.from.getLngLat());
        this.fromStore.set(this.to.getLngLat());
    }
    onMapClick(ev) {
        if (!this.map.requestOwnership(this.OwnershipKey))
            return false;
        if (typeof this.from === "undefined") {
            this.createFromMarker(ev.lngLat);
            this.fromStore.set(ev.lngLat);
        }
        else if (typeof this.to === "undefined") {
            this.createToMarker(ev.lngLat);
            this.toStore.set(ev.lngLat);
        }
        this.map.releaseOwnership(this.OwnershipKey);
        return true;
    }
    createFromMarker(location) {
        const element = document.createElement("div");
        element.className = "marker-from";
        element.innerHTML = "<div class=\"badge badge-lg badge-rounded-circle badge-success-soft mt-1 mr-2 marker\">\n" +
            "\t\t        A\n" +
            "\t\t      </div>";
        element.title = "From";
        this.from = new Marker({
            element,
            draggable: true,
            offset: [0, -4],
        })
            .setLngLat(location);
        this.map.addMarker(this.from);
        this.from.on("dragend", () => {
            this.fromStore.set(this.from.getLngLat());
        });
        element.onclick = (element) => {
            this.from.remove();
            this.from = undefined;
            this.fromStore.set(undefined);
            element.cancelBubble = true;
        };
    }
    createToMarker(location) {
        const element = document.createElement("div");
        element.className = "marker-to";
        element.innerHTML = "<div class=\"badge badge-lg badge-rounded-circle badge-success-soft mt-1 mr-2 marker\">\n" +
            "\t\t        B\n" +
            "\t\t      </div>";
        element.title = "To";
        this.to = new Marker({
            element,
            draggable: true,
            offset: [0, -4],
        })
            .setLngLat(location);
        this.map.addMarker(this.to);
        this.to.on("dragend", async () => {
            this.toStore.set(this.to.getLngLat());
        });
        element.onclick = (element) => {
            this.to.remove();
            this.to = undefined;
            this.toStore.set(undefined);
            element.cancelBubble = true;
        };
    }
    updateScore() {
        const data = [];
        this.profileManagers.forEach((pm) => {
            const visible = get(pm.getVisibleStore());
            if (!visible)
                return;
            const route = get(pm.getRouteStore());
            data.push(route);
        });
        this.scoreStore.set(ScoreUtis.Calculate(data));
    }
}
